import AuthDialog from "./AuthDialog";

export default AuthDialog;
